import React from 'react';
import { useTranslation } from 'react-i18next';

// Multi-select de obras sociales con copago configurable (Consultame, NER-3832).
// Cada cobertura: { key, name, enabled, locked, copayArs, custom }.
// "Particular" viene `locked` (siempre activa, no removible). "Otra" permite
// agregar coberturas custom. El copago en ARS puede ser 0 (sin cargo al paciente).
function CoverageMatrix({ coverages, onChange, loading, error }) {
  const { t } = useTranslation();
  const list = coverages || [];

  const toggle = (idx) => {
    onChange(
      list.map((c, i) => (i === idx ? { ...c, enabled: c.locked ? true : !c.enabled } : c))
    );
  };

  const setCopay = (idx, value) => {
    onChange(
      list.map((c, i) => (i === idx ? { ...c, copayArs: value === '' ? '' : Number(value) } : c))
    );
  };

  const setName = (idx, name) => {
    onChange(list.map((c, i) => (i === idx ? { ...c, name } : c)));
  };

  const removeCustom = (idx) => {
    onChange(list.filter((_, i) => i !== idx));
  };

  const addCustom = () => {
    onChange([
      ...list,
      { key: `custom_${list.length}_${Date.now()}`, name: '', enabled: true, custom: true, copayArs: '' },
    ]);
  };

  return (
    <div className="med-coverage">
      {loading && (
        <p className="sw-hint">
          {t('setupWizardMedical.coverage.loading', 'Cargando catálogo de obras sociales…')}
        </p>
      )}

      <div className="med-coverage-list">
        {list.map((c, idx) => (
          <div key={c.key} className={`med-coverage-row ${c.enabled ? 'is-active' : ''}`}>
            <label className="med-coverage-check">
              <input
                type="checkbox"
                checked={!!c.enabled}
                disabled={c.locked}
                onChange={() => toggle(idx)}
              />
              {c.custom ? (
                <input
                  type="text"
                  className="sw-input med-coverage-name-input"
                  value={c.name}
                  onChange={(e) => setName(idx, e.target.value)}
                  placeholder={t('setupWizardMedical.coverage.customName', 'Nombre de la obra social')}
                />
              ) : (
                <span className="med-coverage-name">
                  {c.name}
                  {c.locked && (
                    <span className="med-coverage-tag">
                      {t('setupWizardMedical.coverage.always', 'siempre activa')}
                    </span>
                  )}
                </span>
              )}
            </label>

            <div className="med-coverage-copay">
              {c.enabled && (
                <label className="med-copay-field">
                  <span className="sw-price-prefix">
                    {t('setupWizardMedical.coverage.copay', 'Copago ARS')}
                  </span>
                  <input
                    type="number"
                    min="0"
                    inputMode="numeric"
                    className="sw-input"
                    value={c.copayArs === '' || c.copayArs === null || c.copayArs === undefined ? '' : c.copayArs}
                    onChange={(e) => setCopay(idx, e.target.value)}
                    placeholder="0"
                  />
                </label>
              )}
              {c.custom && (
                <button
                  type="button"
                  className="btn btn-ghost btn-sm sw-icon-btn"
                  onClick={() => removeCustom(idx)}
                  aria-label={t('setupWizardMedical.coverage.remove', 'Quitar')}
                  title={t('setupWizardMedical.coverage.remove', 'Quitar')}
                >
                  <span className="material-icons">close</span>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <button type="button" className="btn btn-secondary btn-sm med-add-coverage" onClick={addCustom}>
        <span className="material-icons">add</span>
        {t('setupWizardMedical.coverage.addCustom', 'Agregar otra obra social')}
      </button>

      {error && (
        <p className="sw-error">
          {t('setupWizardMedical.errors.coverageInvalid', 'Completá el copago de cada obra social activa (puede ser 0)')}
        </p>
      )}

      <p className="sw-hint">
        {t(
          'setupWizardMedical.coverage.note',
          'Podés actualizar los valores en cualquier momento desde Configuración → Obras Sociales.'
        )}
      </p>
    </div>
  );
}

export default CoverageMatrix;
